var React = require('react');

function FlagGm (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 308.966h512v105.931a8.829 8.829 0 01-8.828 8.828H8.828A8.829 8.829 0 010 414.897V308.966z","fill":"#73af00","key":0}),React.createElement("path",{"d":"M8.828 88.276h494.345a8.829 8.829 0 018.828 8.828v105.931H0V97.103a8.828 8.828 0 018.828-8.827z","fill":"#ff4b55","key":1}),React.createElement("path",{"fill":"#41479b","d":"M0 203.03h512v105.93H0z","key":2}),React.createElement("g",{"fill":"#f5f5f5","key":3},React.createElement("path",{"d":"M0 203.03h512v17.655H0zM0 291.31h512v17.655H0z"}))]);
}

FlagGm.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagGm;

FlagGm.default = FlagGm;
